import { forwardRef, type Ref, type SVGProps } from "react";
const IconPedestrianFilledSVG = (
  { children, ...rest }: SVGProps<SVGSVGElement>,
  ref: Ref<SVGSVGElement>
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
    viewBox="0 0 32 32"
    ref={ref}
    {...rest}
  >
    {children}
    <path d="M10.37 22.55a3.8 3.8 0 0 1-.84 1.25l-2.95 2.92a1.9 1.9 0 0 0 0 2.71 2 2 0 0 0 2.75 0l3.59-3.54a5.3 5.3 0 0 0 .84-1.26l.85-2a36 36 0 0 1-2.85-3.13c-.12.02-1.39 3.05-1.39 3.05" />
    <path d="M24.25 14.34 24 14.2l-1.37-.73-.53-1.67a6.37 6.37 0 0 0-3.45-3.87A3 3 0 0 0 21 5a3 3 0 0 0-6 0 3 3 0 0 0 1.13 2.33H16c-2.11 0-3.38.62-5.6 1.46a5.7 5.7 0 0 0-2.95 2.71l-.32.84c-.25 1.11-.1 2 .83 2.5a1.89 1.89 0 0 0 2.51-.84l.42-.83a2.06 2.06 0 0 1 .95-.94l1.59-.62-.95 3.54a3.67 3.67 0 0 0 .84 3.44l3.59 3.86a3.14 3.14 0 0 1 .84 1.67l1.06 4.28a1.9 1.9 0 0 0 2.32 1.35 1.87 1.87 0 0 0 1.37-2.29l-1.37-5.22a4.9 4.9 0 0 0-.84-1.66l-2.75-2.93 1.06-4.06.31.94a3.65 3.65 0 0 0 1.9 2.19l1.38.73a1.91 1.91 0 0 0 2.53-.84 1.62 1.62 0 0 0-.47-2.27" />
  </svg>
);
const ForwardRef = forwardRef(IconPedestrianFilledSVG);
ForwardRef.displayName = "IconPedestrianFilled";
export { ForwardRef as IconPedestrianFilled };
